import * as actions from './actionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case actions.RESET:
      return []
    case actions.SAVE:
      var newstate = [...state]
      newstate[action.meta.id] = action.payload.answer
      return newstate
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/question/reducer.js